<script setup lang="ts">
type TProps = {
  label?: string;
};
type TSlots = {
  default?: () => unknown;
};

defineProps<TProps>();
defineSlots<TSlots>();
</script>

<template>
  <div class="flex flex-col gap-1">
    <div
      class="text-interface-transparent-white text-sm/5 md:text-base/6 font-medium"
    >
      {{ label }}
    </div>

    <div class="flex gap-1 flex-wrap">
      <slot name="default" />
    </div>
  </div>
</template>
